import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import menusServices from '@src/services/menus.services';

export const getUserMenus = createAsyncThunk('getUserMenus', async (body, { rejectWithValue }) => {
  try {
    return await menusServices.getUserMenus(body);
  } catch (error) {
    return rejectWithValue(error?.data);
  }
});

export const getAdminUserMenus = createAsyncThunk(
  'getAdminUserMenus',
  async (body, { rejectWithValue }) => {
    try {
      return await menusServices.getAdminUserMenus();
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getAllUserMenu = createAsyncThunk(
  'getAllUserMenu',
  async (body, { rejectWithValue }) => {
    try {
      return await menusServices.getAllUserMenu();
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  menus: [],
  vouIdList: [],
};

export const menusSlice = createSlice({
  name: 'menus',
  initialState,
  reducers: {
    menuChange: (state, action) => {
      state.selectedKey = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserMenus.fulfilled, (state, action) => {
      state.menus = action?.payload?.data;
      state.vouIdList = extractVouIds(state.menus);
    });
    builder.addCase(getAdminUserMenus.fulfilled, (state, action) => {
      const menus = action?.payload?.data || [];
      const collabse = menus[0].userSubMenus || [];
      const c = collabse.map((c) => {
        c.key = '/admin' + c.key;
        return c;
      });
      menus[0].userSubMenus = c;
      state.menus = menus;
    });
  },
});

const vouIdSet = new Set();

function extractVouIds(menu) {
  if (!Array.isArray(menu) || menu.length === 0) return [];
  menu.forEach(item => {
    if (item.vouId) {
      vouIdSet.add(item.vouId);
    }
    if (item.userSubMenus && item.userSubMenus.length > 0) {
      extractVouIds(item.userSubMenus);
    }
  });
  return Array.from(vouIdSet);
}

export const { menuChange, vouIdList } = menusSlice.actions;
